
const SET_LOADING = (state, loading) => {
  state.loading = loading;
};
const SET_PURCHASE_ORDERS = (state, purchaseOrders) =>{
  state.purchaseOrders = purchaseOrders;
}
const SET_COUNT = (state, count)=>{
  state.count = count;
}
const SET_PAGES = (state, pages)=>{
  state.pages = pages;
}
const SET_PAGE = (state, page)=>{
  state.page = page;
}
const INVALIDATE_LIST = (state) =>{
  state.outDated=true;
}
const SET_INVENTORY_ID = (state, inventoryId)=>{
  state.inventoryId = inventoryId;
}

const SET_ORDER_BY = (state, orderBy)=>{
  state.orderBy = orderBy;
}

const SET_SORT_ICON = (state, sortIcon)=>{
  state.sort_icon = sortIcon;
}

const SET_SEARCH_TERMS = (state, searchTerms)=>{
  state.searchTerms = searchTerms
}
const SET_SELECTED_INDEX = (state, selectedIndex)=>{
  state.selectedIndex=selectedIndex;
}
const SET_SELECTED_PURCHASE_ORDER = (state, selectedPurchaseOrder)=>{
  state.selectedPurchaseOrder=selectedPurchaseOrder;
  if (state.selectedIndex != null) {
    Object.assign(state.purchaseOrders[state.selectedIndex], selectedPurchaseOrder)
  }
}
const ASSIGN_SELECTED_PURCHASE_ORDER = (state, selectedPurchaseOrder)=>{
  Object.assign(state.selectedPurchaseOrder,selectedPurchaseOrder)
  if (state.selectedIndex != null) {
    Object.assign(state.purchaseOrders[state.selectedIndex], selectedPurchaseOrder)
  }
}

const SET_PURCHASE_ORDER_HISTORIC_ACTIVITIES = (state, activities)=>{
  state.selectedPurchaseOrderHistoricActivities= activities;
}

const SET_LOADING_SELECTED_PURCHASE_ORDER = (state, selectedPurchaseOrderLoading)=>{
  state.loadingSelectedPurchaseOrder=selectedPurchaseOrderLoading;
}

const SET_ITEM_IN_CORRECTION = (state, {index, in_correction})=>{
  state.selectedPurchaseOrder.lines[index].in_correction = in_correction;
}

const UPDATE_PURCHASE_ORDERS = (state, purchaseOrders)=>{
  state.purchaseOrders.push(...purchaseOrders);
}

const SET_MODE = (state, mode)=>{
  state.mode = mode;
}

const SET_STATUS_FILTER = (state, statusFitler)=>{
  state.filters.status = statusFitler;
}

const SET_DATE_FILTER = (state, dateFilter)=>{
  state.filters.date = dateFilter;
}

const SET_YEAR_FILTER = (state, yearFilter)=>{
  state.filters.year = yearFilter;
}

const SET_AVAILABILITY_DATE_FILTER = (state, availabilityDate)=>{
  state.filters.availabilityDate = availabilityDate;
}

const SET_AVAILABILITY_YEAR_FILTER = (state, availabilityYearFilter)=>{
  state.filters.availabilityYear = availabilityYearFilter;
}


const RESET_FILTERS = (state)=>{
  state.filters.status = [];
  state.filters.date = null;
  state.filters.year = null;
  state.filters.availabilityDate = null;
  state.filters.availabilityYear = null;
  state.searchTerms = null;
}

const SET_SELECTED_PURCHASE_ORDER_PRODUCTS = (state, selectedPurchaseOrderProducts) => {
  state.selectedPurchaseOrderProducts = selectedPurchaseOrderProducts
}
const SET_SELECTED_PURCHASE_ORDER_PRODUCT_ITEMS = (state, selectedPurchaseOrderProductItems) => {
  state.selectedPurchaseOrderProductItems = selectedPurchaseOrderProductItems
}

export default {
  SET_LOADING,
  SET_PURCHASE_ORDERS,
  SET_COUNT,
  SET_PAGES,
  SET_PAGE,
  SET_INVENTORY_ID,
  INVALIDATE_LIST,
  SET_ORDER_BY,
  SET_SORT_ICON,
  SET_SEARCH_TERMS,
  SET_SELECTED_INDEX,
  SET_SELECTED_PURCHASE_ORDER,
  ASSIGN_SELECTED_PURCHASE_ORDER,
  SET_PURCHASE_ORDER_HISTORIC_ACTIVITIES,
  SET_LOADING_SELECTED_PURCHASE_ORDER,
  SET_ITEM_IN_CORRECTION,
  UPDATE_PURCHASE_ORDERS,
  SET_MODE,
  SET_STATUS_FILTER,
  SET_DATE_FILTER,
  RESET_FILTERS,
  SET_YEAR_FILTER,
  SET_AVAILABILITY_DATE_FILTER,
  SET_AVAILABILITY_YEAR_FILTER,
  SET_SELECTED_PURCHASE_ORDER_PRODUCT_ITEMS,
  SET_SELECTED_PURCHASE_ORDER_PRODUCTS
};
